import { LiveningIcpSite } from "../../types/LiveningIcpSite";

export const countAllSiteUnits = (sites: LiveningIcpSite[]) => {
  return sites
    .map((site) => site.manualUnits)
    .reduce((previousUnit, currentUnit) => {
      return [...previousUnit, ...currentUnit];
    }).length;
};
